/**
 * predicate is nothing
 * @param a
 */
const isNothing=(a):boolean=> a == null;
export default isNothing;


// WEBPACK FOOTER //
// ./src/isNothing.ts